import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { CompleteProfile } from './completeprofile';
import { ValidationService } from '../../shared/services/validation.service';
import { KeyboardServiceService } from '../../shared/keyboard-service/keyboard-service.service';
import { StatesService } from '../../shared/services/states.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-completeprofile',
  templateUrl: './completeprofile.component.html',
  styleUrls: ['./completeprofile.component.scss']
})
export class CompleteprofileComponent implements OnInit {
  showError: boolean = false;
  showFinalModal: boolean = false;
  signUpArray = ['address', 'address2', 'city', 'state', 'phone', 'birthday'];
  signup = new CompleteProfile('', '', '', '', '', '');
  allStates: any[];
  bodyUdate: HTMLElement;

  phoneMask: any = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  dateMask: any = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  error = {};

  constructor (
    private keyboardSvc: KeyboardServiceService,
    private states: StatesService,
    private dataSvc: DatabusService,
    private validate: ValidationService,
    private idle: Idle,
    private router: Router 
  ){ 
    this.allStates = this.states.get();

    this.keyboardSvc.isNumberPad = false;
    this.keyboardSvc.currentModel = this.signUpArray[0];

    this.bodyUdate = document.getElementById('main-stage');
    this.bodyUdate.style.backgroundColor = 'rgba(40, 167, 69, 0.8)'
  }

  isCurrent (name) {
    return this.keyboardSvc.currentModel === name;
  }

  TabToNextField(val) {
    let currentIdx = this.signUpArray.indexOf(this.keyboardSvc.currentModel);
    if(val === 'NEXT' && currentIdx !== this.signUpArray.length - 1) {
      this.keyboardSvc.currentModel = this.signUpArray[currentIdx + 1]
    } else if(currentIdx !== 0) {
      this.keyboardSvc.currentModel = this.signUpArray[currentIdx - 1]
    }
  }

  SetModelFromKeyboard (val) {
    let currentModel = this.keyboardSvc.getCurrentModel();
    if (val === 'DELETE') {
      this.signup[currentModel] = this.keyboardSvc.deleteValue(this.signup[currentModel]);
    } else if (val === 'NEXT' || val === "PREV") {
      this.TabToNextField(val);
    } else {
      this.signup[currentModel] = this.signup[currentModel] + val;
    }
  }

  Cancel() {
    //Cancel extended profile
    this.router.navigate(['/scanticket']);
  }

  CloseError () {
    this.showError = false;
  }

  SaveProfile() {
    //Save extended profile
    this.dataSvc.setExtendProfile(this.signup)
    let validProfile = this.dataSvc.extendProfileValid();
    if(validProfile) {
      this.FinalSave();
    } else {
      this.error = {
        address: this.signup.address === '' ? true : false,
        city: this.signup.city === '' ? true : false,
        state: this.signup.state === '' ? true : false,
        phone: this.signup.phone === '' ? true : false,
        zip: this.signup.zip === '' ? true : false,
        birthday: this.signup.birthday === '' ? true : false,
      }
      this.showError = true;
    }
  }

  FinalSave() {
    let profile = {
      email: this.dataSvc.currentEmail,
      password: this.dataSvc.password,
      city: this.signup.city,
      state: this.signup.state,
      address: this.signup.address,
      zip: this.signup.zip,
      phone: this.signup.phone,
      birthday: this.signup.birthday
    };
    this.validate.completeProfile(profile)
    .then((results) => {
      if(results.status === "201") {
        this.router.navigate(['/finalsuccess']);
      } else {
        this.showFinalModal = true;
      }
    })    
  }

  ngOnInit() {
    this.keyboardSvc.resetValue();
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

  ngOnDestroy(){
    this.bodyUdate.style.backgroundColor = 'rgba(90, 25, 114, 0.8)';
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/completeprofile/completeprofile.component.ts